class Global {
    static ASM_EMAIL_NO_REPLY = 'noreply@auvik.com';
}

export default Global;
